import { fg } from '@confluence/feature-gating';
import { useObjectSidebarActions } from '@confluence/object-sidebar-api';

export const useCloseAllOpenSidePanels = () => {
	const { hideObjectSidebar } = useObjectSidebarActions();

	const closeAllOpenSidePanels = () => {
		window.dispatchEvent(new Event('closeGlobalSidebar'));
		if (fg('confluence_frontend_object_sidebar')) {
			hideObjectSidebar();
		}
	};

	return { closeAllOpenSidePanels };
};
